export default __webpack_public_path__ + "static/toolbar-view-actions-light-mode-02c67ebfab4da1b46cbc988f3996a7b2.png";